import React from 'react';
import PointTypeLoader from '../loaders/PointTypeLoader';
import EquipTypeLoader from '../loaders/EquipTypeLoader';
import TagsLoader from '../loaders/TagsLoader';
import LabelsLoader from '../loaders/LabelsLoader';
import UnitsLoader from '../loaders/UnitsLoader';
import MeasurementsLoader from '../loaders/MeasurementsLoader';
import ModelRouter from './ModelRouter';

/**
 * Outer page container for the data model explorer page - loads data and kicks off
 * subview routing
 */
const DataModelPage = () => (
  <>
    <PointTypeLoader />
    <EquipTypeLoader />
    <TagsLoader />
    <LabelsLoader />
    <UnitsLoader />
    <MeasurementsLoader />
    <ModelRouter base="/data-model" />
  </>
);

export default DataModelPage;
